// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2e9c5c50]:export{primaryColor:#64b5f6;secondaryColor:#003c60;accentColor:#c41230}.blue-subtitle[data-v-2e9c5c50]{color:#005cab}.green-subtitle[data-v-2e9c5c50]{color:#006c39!important}h3[data-v-2e9c5c50]{font-style:normal}.underlined[data-v-2e9c5c50]{text-decoration:underline;font-weight:600;color:#005cab;margin:0}.italics[data-v-2e9c5c50]{font-style:italic;margin-bottom:0}.sty[data-v-2e9c5c50]{font-style:normal}", ""]);
// Exports
module.exports = exports;
